import { DealerID } from "./Dealer";

export type DBBLeaseCompanyID = number;

export interface DBBLeaseCompany {
  created_on: string;
  updated_on: string;
  id: DBBLeaseCompanyID; // Claire DBB Lease Company ID
  name: string; // Lease company name
  street: string; // Lease company address street
  number: string; // Lease company address street number
  postalcode: string; // Lease company address postal code
  city: string; // Lease company address city
  country: string; // Lease company address country
  dealer_id: DealerID; // Dealer this lease company belongs to
}

export interface DBBLeaseCompanySummary {
  id: DBBLeaseCompanyID; // Lease company ID
  name: string; // Lease company name
}
